import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";

import { alignItems, routePaths, strCode } from "../../consts";
import { navigationService, t } from "../../services";
import { withSection } from "../../hoc";

import {
  useCreateReleaseNotes,
  useDeleteReleaseNotes,
  useFetchFWUVersions,
  useFetchReleaseNotes,
  useUpdateFWUVersion,
  useUpdateReleaseNotes
} from "../../apiHooks";

import { NewFirmwareVerionForm } from "../../containers";
import { FlexContainers, Heading5, PageContainer, WrapperContainer } from "../../components";

const EditFwVersionPage = () => {
  const { fwuName } = useParams();
  const [fwuVersionToEdit, setFwuVersionToEdit] = useState(null);

  const fetchAttemted = useRef(false);

  const {
    data: fwuVersions,
    fetchCallback: fetchFWUVersions,
    loading: fwuVersionsloading
  } = useFetchFWUVersions();

  const {
    fetchCallback: fetchReleaseNotes,
    data: releaseNotes,
    loading: releaseNotesLoading
  } = useFetchReleaseNotes();

  const { mutationCallback: updateFWUVersion, loading } = useUpdateFWUVersion();
  const { mutationCallback: createReleaseNotes, loading: createReleaseNotesLoading } =
    useCreateReleaseNotes();
  const { mutationCallback: updateReleaseNotes, loading: updateReleaseNotesLoading } =
    useUpdateReleaseNotes();
  const { mutationCallback: deleteReleaseNotes, loading: deleteReleaseNotesLoading } =
    useDeleteReleaseNotes();

  const onUpdateFwuVersion = (_, binFile, signatureFile) => {
    return updateFWUVersion(fwuName, binFile, signatureFile);
  };

  const onSaveReleaseNotes = (releaseNotes, mediaData, isNew) => {
    if (!releaseNotes?.localizations) {
      return deleteReleaseNotes(releaseNotes?.version);
    }

    return isNew
      ? createReleaseNotes(releaseNotes, mediaData)
      : updateReleaseNotes(releaseNotes, mediaData);
  };

  useEffect(() => {
    if (fwuVersions && !fwuVersionsloading) {
      const fwuVersion = fwuVersions.find((el) => el.fwuName === fwuName);
      if (fwuVersion) {
        setFwuVersionToEdit(fwuVersion);
      } else if (!fwuVersion?.lenght && !fetchAttemted?.current) {
        fetchFWUVersions(true);
        fetchAttemted.current = true;
      } else {
        navigationService.redirect(routePaths.FLEET_MANAGEMENT);
      }
    }
  }, [fwuName, fwuVersions, fwuVersionsloading]);

  useEffect(() => {
    if (fwuName) {
      fetchReleaseNotes(fwuName);
    }
  }, [fwuName]);

  return (
    <PageContainer alignItems={alignItems.start}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width="100%">
        <Heading5>{t(strCode.EDIT_FIRMWARE_TITLE)}</Heading5>

        <NewFirmwareVerionForm
          fwuVersionData={fwuVersionToEdit}
          releaseNotes={releaseNotes}
          isLoading={
            loading ||
            createReleaseNotesLoading ||
            updateReleaseNotesLoading ||
            deleteReleaseNotesLoading
          }
          releaseNotesLoading={releaseNotesLoading || fwuVersionsloading}
          onSaveFwVersion={onUpdateFwuVersion}
          onSaveReleaseNotes={onSaveReleaseNotes}
        />
      </WrapperContainer>
    </PageContainer>
  );
};

export default withSection(EditFwVersionPage);
